import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.find.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import UploadFileService from '@/services/upload-file.service';
export default {
  name: 'CreationSecondStep',
  props: {
    existing: {
      type: [Object, Array],
      required: false,
      default: function _default() {
        return {};
      }
    },
    nextStep: {
      type: Function,
      required: true
    },
    previousStep: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      uploading: false,
      seriesTrailerFile: '',
      seriesThumbnailFile: '',
      seriesDesktopCoverFile: '',
      seriesMobileCoverFile: '',
      seriesCategory: null,
      processingCoverImage: false,
      processingDesktopImage: false,
      processingMobileImage: false,
      storageUrl: process.env.NODE_ENV === 'production' ? 'https://storage.googleapis.com/telos-assets/' : 'https://storage.googleapis.com/telos-assets-staging/'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    categories: 'category/categories',
    user: 'user/me'
  })), {}, {
    isSelected: function isSelected() {
      return this.seriesCategory ? this.seriesCategory : false;
    },
    dataFormat: function dataFormat() {
      var _this$seriesCategory, _this$user, _this$user2;

      var format = {
        categoryId: (_this$seriesCategory = this.seriesCategory) === null || _this$seriesCategory === void 0 ? void 0 : _this$seriesCategory.id,
        trailer: this.seriesTrailerFile,
        defaultImageFile: this.seriesThumbnailFile,
        desktopImageFile: this.seriesDesktopCoverFile,
        mobileImageFile: this.seriesMobileCoverFile,
        lastModifiedByUserId: (_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.id,
        creatorId: (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.id
      };
      return format;
    },
    isNextStepDisabled: function isNextStepDisabled() {
      return !(this.seriesCategory && !this.uploading && this.seriesThumbnailFile && this.seriesThumbnailFile.length > 0);
    }
  }),
  beforeMount: function beforeMount() {
    var _this = this,
        _this$existing;

    this.$store.dispatch('user/findMe').then(function () {
      _this.$store.dispatch('category/findAll', {
        page: 1,
        limit: 20,
        search: ''
      });
    });

    if ((_this$existing = this.existing) !== null && _this$existing !== void 0 && _this$existing.id) {
      this.seriesTrailerFile = this.existing.trailer;
      this.seriesThumbnailFile = this.existing.defaultImageFile;
      this.seriesMobileCoverFile = this.existing.mobileImageFile;
      this.seriesDesktopCoverFile = this.existing.desktopImageFile;
      this.seriesCategory = this.existing.categoryId;
    }
  },
  methods: {
    resetTrailer: function resetTrailer() {
      this.seriesTrailerFile = '';
    },
    resetThumbnailFile: function resetThumbnailFile(data) {
      this.$data[data] = '';
    },
    uploadingTrailer: function uploadingTrailer(value) {
      this.uploading = value;
    },
    loadVideoFile: function loadVideoFile(data) {
      this.seriesTrailerFile = data.filename.filename;
    },
    loadThumbnailFile: function loadThumbnailFile(data, process, target) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$data[process] = true;
                _context.next = 3;
                return UploadFileService.uploadFile(data).then(function (filename) {
                  _this2.$data[target] = filename.filename;
                  _this2.$data[process] = false;
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selectCategory: function selectCategory(id) {
      this.seriesCategory = this.categories.find(function (category) {
        return category.id === id;
      });
    }
  }
};